import React from 'react';
import PropTypes from 'prop-types';

const KeyFilled = ({ color = '#B5BDC5' }) => (
    <svg
        width="18px"
        height="18px"
        viewBox="0 0 18 18"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g
            id="Svg-Icons/18px-(All-icons)/UI/key-filled-18px"
            stroke="none"
            strokeWidth="1"
            fill="none"
            fillRule="evenodd"
        >
            <rect
                id="Bounds"
                fillOpacity="0.1"
                fill="#FF0000"
                opacity="0"
                x="0"
                y="0"
                width="18"
                height="18"
            />
            <path
                d="M10.7929675,7.5 L18,7.5 L18,10.5 L16,10.5 L16,14 L14,14 L14,10.5 L10.7929675,10.5 C10.1400386,12.8085048 8.01755425,14.5 5.5,14.5 C2.46243388,14.5 0,12.0375661 0,9 C0,5.96243388 2.46243388,3.5 5.5,3.5 C8.01755425,3.5 10.1400386,5.1914952 10.7929675,7.5 Z M5.5,12.5 C7.43299662,12.5 9,10.9329966 9,9 C9,7.06700338 7.43299662,5.5 5.5,5.5 C3.56700338,5.5 2,7.06700338 2,9 C2,10.9329966 3.56700338,12.5 5.5,12.5 Z"
                id="Combined-Shape"
                fill={color}
                className="icon-color"
            />
        </g>
    </svg>
);

KeyFilled.propTypes = {
    color: PropTypes.string,
};

export default KeyFilled;
